import { render, staticRenderFns } from "./BusinessDetailsSection.vue?vue&type=template&id=67909b3e&scoped=true"
import script from "./BusinessDetailsSection.vue?vue&type=script&lang=js"
export * from "./BusinessDetailsSection.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetailsSection.vue?vue&type=style&index=0&id=67909b3e&prod&scoped=true&lang=css"
import style1 from "./BusinessDetailsSection.vue?vue&type=style&index=1&id=67909b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67909b3e",
  null
  
)

export default component.exports